
import '../Css/styles2.css'
import '../Css/bootstrap.css'
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';


function Footer() {
    function scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth', // You can use 'auto' for instant scrolling without animation
        });
    }


    return (
        <div>
            <div className="container-fluid footer bg-dark wow fadeIn" data-wow-delay=".3s">
                <div className="container pt-5 pb-4">
                    <div className="row g-5">
                        <div className="col-lg-3 col-md-6">
                            <a href="">
                                <h1 className="text-white fw-bold d-block">UPSYS<span className="text-secondary">.in</span> </h1>
                            </a>
                            <p className="mt-4 text-light">Our mission is to bridge the gap between exceptional quality and rapid
                                solutions. We understand the challenges organizations face in today's fast-paced world, and our
                                mission is to be the reliable partner that ensures you never have to compromise on either
                                quality or time.
                            </p>
                            <div className="d-flex hightech-link">
                                <a href="https://www.facebook.com/profile.php?id=100094900818238&mibextid=ZbWKwL" className="btn-light nav-fill btn btn-square rounded-circle me-2"><i className="fab fa-facebook-f text-primary" /></a>
                                {/* <a href className="btn-light nav-fill btn btn-square rounded-circle me-2"><i className="fab fa-twitter text-primary" /></a> */}
                                <a href="https://instagram.com/upsys.in?igshid=MzRlODBiNWFlZA==" className="btn-light nav-fill btn btn-square rounded-circle me-2"><i className="fab fa-instagram text-primary" /></a>
                                <a href="https://www.linkedin.com/company/upsys-it-and-marketing-solutions/" className="btn-light nav-fill btn btn-square rounded-circle me-0"><i className="fab fa-linkedin-in text-primary" /></a>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <a href="#" className="h3 text-secondary">Short Link</a>
                            <div className="mt-4 d-flex flex-column short-link">
                                <Link to="/Company">  <a onClick={scrollToTop} href className="mb-2 text-white"><i className="fas fa-angle-right text-secondary me-2" />About
                                    us</a></Link>
                                <Link to="/contact">   <a onClick={scrollToTop} href className="mb-2 text-white"><i className="fas fa-angle-right text-secondary me-2" />Contact
                                    us</a></Link>
                                <Link to="/services">   <a onClick={scrollToTop} href className="mb-2 text-white"><i className="fas fa-angle-right text-secondary me-2" />Our
                                    Services</a></Link>
                                {/* <a href className="mb-2 text-white"><i className="fas fa-angle-right text-secondary me-2" />Our
                                    Projects</a> */}
                                {/* <a href className="mb-2 text-white"><i className="fas fa-angle-right text-secondary me-2" />Latest
                                    Blog</a> */}
                            </div>
                        </div>
                        {/* <div className="col-lg-3 col-md-6">
                            <a href="#" className="h3 text-secondary">Help Link</a>
                            <div className="mt-4 d-flex flex-column help-link">
                                <a href className="mb-2 text-white"><i className="fas fa-angle-right text-secondary me-2" />Terms
                                    Of use</a>
                                <a href className="mb-2 text-white"><i className="fas fa-angle-right text-secondary me-2" />Privacy
                                    Policy</a>
                                <a href className="mb-2 text-white"><i className="fas fa-angle-right text-secondary me-2" />Helps</a>
                                <a href className="mb-2 text-white"><i className="fas fa-angle-right text-secondary me-2" />FAQs</a>
                            </div>
                        </div> */}
                        <div className="col-lg-3 col-md-6">
                            <a href="#" className="h3 text-secondary">Contact Us</a>
                            <div className="text-white mt-4 d-flex flex-column contact-link">
                                <a
                                    href="https://www.google.com/maps/search/Bhawarkua+Square,+Indore"
                                    target="_blank"
                                    className="pb-3 text-light border-bottom border-primary"
                                >
                                    <i className="fas fa-map-marker-alt text-secondary me-2" />Indore, India
                                </a>

                                <a
                                    href="mailto:contact@upsys.in"
                                    className="py-3 text-light border-bottom border-primary"
                                >
                                    <i className="fas fa-envelope text-secondary me-2" /> contact@upsys.in
                                </a>
                                <a
                                    href="tel:+918223065170"
                                    className="py-3 text-light border-bottom border-primary"
                                >
                                    <i className="fas fa-phone-alt text-secondary me-2" /> +91 8223065170
                                </a>

                            </div>
                        </div>
                    </div>
                    <hr className="text-light mt-5 mb-4" />
                    <div className="row">
                        <div className="col-md-6 text-center text-md-start center" >
                            <span className="text-light">
                                <a href="#" className="text-secondary">
                                    <i className="fas fa-copyright text-secondary me-2" />
                                    {new Date().getFullYear()} UPSYS
                                </a>, All rights reserved .
                            </span>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    )
}

export default Footer
